<template>
	<!-- Pipe: no rotation panel — a local Z delta only spins the cylinder about
	     its own axis (visual no-op); azimuth/gradient are edited in the
	     double-point panel, which is the sole orientation editor for pipes. -->
	<SolidMeshTransformPanelSinglePoint v-if="isParametric && !isPipe" :solidMeshId="solidMeshId" :isEditing="isEditing"
		@transform-reset="$emit('transform-reset', $event)" />
	<SolidMeshTransformPanelManual v-else-if="!isParametric" :solidMeshId="solidMeshId" :isEditing="isEditing"
		@transform-reset="$emit('transform-reset', $event)" />
</template>

<script>
import {
	SIMPLE_STRUCTURE_TYPE,
	isParametricStructure,
} from "@/models/objects/solidMesh/types";
import { ObjectType } from "@/models/objects/types";
import SolidMeshTransformPanelManual from "./SolidMeshTransformPanelManual.vue";
import SolidMeshTransformPanelSinglePoint from "./SolidMeshTransformPanelSinglePoint.vue";

export default {
	name: "SolidMeshTransformPanel",
	components: {
		SolidMeshTransformPanelManual,
		SolidMeshTransformPanelSinglePoint,
	},
	props: {
		solidMeshId: String,
		isEditing: {
			type: Boolean,
			default: false,
		},
	},
	emits: ["transform-reset"],
	computed: {
		solidMesh() {
			return this.$store.state.object.objects.find(
				(obj) =>
					obj.type === ObjectType.SOLID_MESH && obj.id === this.solidMeshId,
			);
		},
		isParametric() {
			const st =
				this.solidMesh?.metaData?.attributes?.structureType ??
				this.solidMesh?.attributes?.structureType;
			return this.solidMesh && isParametricStructure(st);
		},
		isRetainingWall() {
			const st =
				this.solidMesh?.metaData?.attributes?.structureType ??
				this.solidMesh?.attributes?.structureType;
			return st === SIMPLE_STRUCTURE_TYPE.RETAINING_WALL;
		},
		isPipe() {
			const st =
				this.solidMesh?.metaData?.attributes?.structureType ??
				this.solidMesh?.attributes?.structureType;
			return st === SIMPLE_STRUCTURE_TYPE.PIPE;
		},
	},
};
</script>
